module.exports = __webpack_public_path__ + "static/media/detail_0003_f.560a1c67.jpg";